import { RootState } from 'app/store/rootReducer';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export default function InspectorGetDefaultProfile() {
  const { user } = useSelector((state: RootState) => state.auth);

  if (!user || !user.inspectorProfile?.id) {
    console.error('No inspector profile found');
    return <Navigate to={`/agency/dashboard`} />;
  }

  return <Navigate to={`/agency/inspector/${user.inspectorProfile.id}/main`} />;
}
